__turbopack_context__.v({
  "className": "bebas_neue_53a06137-module__r5NBZG__className",
});
